import React, { useState, useEffect } from 'react';
import supabase from './SupabaseClient';
import CouponPopup from './AddCoupon';

const Footer = ({ language }) => {
  const [session, setSession] = useState(null);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        setSession(session);
      }
    );

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  const texts = {
    en: {
      contactSupport: 'Contact Support',
      pricing: 'Pricing',
      availableStores: 'Available Stores',
      termsOfUse: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
    },
    fr: {
      contactSupport: 'Contacter le Support',
      pricing: 'Tarification',
      availableStores: 'Magasins Disponibles',
      termsOfUse: 'Conditions d\'Utilisation',
      privacyPolicy: 'Politique de Confidentialité',
    },
    es: {
      contactSupport: 'Contactar Soporte',
      pricing: 'Precios',
      availableStores: 'Tiendas Disponibles',
      termsOfUse: 'Términos de Uso',
      privacyPolicy: 'Política de Privacidad',
    },
    de: {
      contactSupport: 'Support Kontaktieren',
      pricing: 'Preise',
      availableStores: 'Verfügbare Geschäfte',
      termsOfUse: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzrichtlinie',
    },
    lt: {
      contactSupport: 'Susisiekti su Pagalba',
      pricing: 'Kainos',
      availableStores: 'Pasiekiamos Parduotuvės',
      termsOfUse: 'Naudojimo Sąlygos',
      privacyPolicy: 'Privatumo Politika',
    },
  };

  const t = texts[language];
  const triggerClass = "footerTrggrs pntr footerLinksBlocks";

  return (
    <footer className='mainFooter redBG'>
      <div className='logoBlock'>
        <img className='footerLogo' src="Thryllo_Price_Tracker_Footer_Logo.svg" alt="Thryllo Price Tracker Footer Logo" />
        <p className='smallP noMarginP lightText'>© 2025 Thryllo - Price Tracker</p>
      </div>

      <div className='footerNdBlocks'>
        <div className="footerLinks">
          <div className='footerLinksBlocks'>
            <a href="/blog" target="_blank">Blog</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="https://blog.thryllo.com/how-to-track-prices-on-amazon" target="_blank" rel="noreferrer">How to Track Amazon Prices with Thryllo</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="https://blog.thryllo.com/how-to-track-prices-on-walmart" target="_blank" rel="noreferrer">How to Track Walmart Prices with Thryllo</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="https://blog.thryllo.com/how-to-track-prices-on-home-depot" target="_blank" rel="noreferrer">How to Track Home Depot Prices with Thryllo</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="https://blog.thryllo.com/how-to-track-prices-on-best-buy" target="_blank" rel="noreferrer">How to Track Best Buy Prices with Thryllo</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="https://blog.thryllo.com/how-to-track-prices-on-etsy" target="_blank" rel="noreferrer">How to Track Etsy Prices with Thryllo</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="https://blog.thryllo.com/how-to-track-prices-on-ebay" target="_blank" rel="noreferrer">How to Track eBay Prices with Thryllo</a><br />
          </div>
        </div>

        <div className="footerLinks">
          {session ? (
            <>
              <CouponPopup userID={session.user.id} triggerClass={triggerClass} />
              <div className='footerLinksBlocks'>
                <a href="/support" target="_blank">{t.contactSupport}</a><br />
              </div>
            </>
          ) : (
            <div className='footerLinksBlocks'>
              <a href="/plans" target="_blank">{t.pricing}</a><br />
            </div>
          )}
          <div className='footerLinksBlocks'>
            <a href="/stores" target="_blank">{t.availableStores}</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="/terms" target="_blank">{t.termsOfUse}</a><br />
          </div>
          <div className='footerLinksBlocks'>
            <a href="/privacy" target="_blank">{t.privacyPolicy}</a><br />
          </div>
        </div>
      </div>

    </footer>
  );
}

export default Footer;